import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { BasePage } from './../../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoadingController, ToastController, Platform } from '@ionic/angular';

@Component({
  selector: 'shc-verify-email',
  templateUrl: './verify-email.page.html',
  styleUrls: ['./verify-email.page.scss'],
})
export class VerifyEmailPage extends BasePage implements OnInit {
  email: string;
  verifyForm: UntypedFormGroup;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
    this.route.params.subscribe(res => {
      this.email = this.router.getCurrentNavigation().extras?.state?.email;
    });
  }

  ngOnInit() {
    this.verifyForm = new UntypedFormGroup({
      email: new UntypedFormControl(this.email, [Validators.required]),
      token: new UntypedFormControl(null, [Validators.required])
    });
  }

  onPinCodeComplete(value) {
    this.verifyForm.patchValue({
      email: this.email,
      token: value
    });
    this.onVerifyEmail();
  }

  onVerifyEmail(): void {
    if (this.verifyForm.invalid) {
      return;
    }
    this.showLoader();
    this.authService.emailVerification(this.verifyForm.value).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(
      res => {
        this.router.navigate(['auth', 'login']);
      },
      error => {
        this.errorService.handle(error);
      }
    );
  }

  onResendEmail(): void {
    this.showLoader();
    this.authService.resendVerificationCode({ email: this.email }).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(res => {

      this.showToast(this.translate.instant(marker('Auth.ResentCode'), { email: this.email}));
    },
      error => {
        this.errorService.handle(error);
      }
    );
  }

  routeToWelcome() {
    this.router.navigate(['auth/login']);
  }

}
